import * as React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PlayerContextConsumer, PlaybackManager, PlayerContext, PlayerState, AudioVideoDefaultProps, DynamicPlaylist, AddToHistory, FullPlaybackMediaInfo, Loader, PAUSE_SMALL_WHITE_SVG, BPMAlbum, BPMMedia } from 'bpm-web-generic';
import { BrowseDropDown } from '../BrowseDropDown';
import { PLAY_SMALL_WHITE_SVG } from 'src/assets';
import { shareAlbum } from 'src/manager/ShareManager';

export interface GridListProps extends AudioVideoDefaultProps {
    albums: BPMAlbum[],
    headline: string,
    viewAll: boolean,
    context: string;
    onViewAllClick: () => void
    onItemClick?: (item: BPMAlbum) => void
}

export default class GridList extends React.Component<GridListProps, { loadingId?: number | string, leftArrowDisabled: boolean, rightArrowDisabled: boolean }> {

    private internallist: DynamicPlaylist;
    constructor(props: any) {
        super(props);
        this.state = {
            leftArrowDisabled: true,
            rightArrowDisabled: true
        }
        this.internallist = new DynamicPlaylist([], {
            history_mode: AddToHistory.ALL
        }, this.props.context, false)
        if (this.props.albums) {
            this.internallist.replace(this.props.albums.map(album => {
                return {
                    album,
                    track: album.media[0],
                    playbackInfo: album.media[0].stream_info,
                    playlist: this.internallist
                } as FullPlaybackMediaInfo
            }))
        }
    }

    private onAlbumSelected(album: BPMAlbum, queue: boolean = false) {
        if (queue) {
            PlaybackManager.getInstance().getContentManager().appendList(new DynamicPlaylist([{
                album,
                track: album.media[0],
                playbackInfo: album.media[0].stream_info
            }], {
                history_mode: AddToHistory.ALL
            }, Math.random().toString(), false))
            if (PlaybackManager.getInstance().getPlayingState() == PlayerState.None) {
                PlaybackManager.getInstance().play()
                PlaybackManager.getInstance().startTrack(PlaybackManager.getInstance().getContentManager().getTracks()[0])
            }
        } else {
            PlaybackManager.getInstance().getContentManager().replaceLists(this.internallist)
            PlaybackManager.getInstance().startTrack(this.internallist.tracks().find(a => a.album.id == album.id)!)
            this.props.onAlbumSelected && this.props.onAlbumSelected(album)
        }
    }
    render() {
        const { headline, albums, viewAll, onViewAllClick, onItemClick } = this.props
        let odd = matchMedia('(min-width: 992px)').matches
        return (
            <>
                <div className="gridlist-header">
                    {headline && <span className="headline">{headline}</span>}
                    {viewAll && <span className="viewall" onClick={onViewAllClick}>See All</span>}
                </div>

                <Container className='browse-gridlist no-scrollbar'>
                    <Row>
                        {albums.slice(0, (!odd) ? Math.floor(albums.length / 2) * 2 : Math.floor(albums.length / 3) * 3).map((album) => {
                            return (
                                <Col key={album.id} xs="12" md="6" lg="4" className="ml-auto">
                                    <GridListItem  {...this.props}
                                        album={album}
                                        loading={this.state.loadingId == album.id}
                                        onItemClick={onItemClick ? () => {
                                            onItemClick(album)
                                        } : undefined}
                                        onPlay={() => {
                                            this.onAlbumSelected(album)
                                        }} onAddToQueue={() => {
                                            this.onAlbumSelected(album, true)
                                        }} onDownload={(m) => {
                                            this.props.onMediaDownlod && this.props.onMediaDownlod(m, false)
                                        }} onAddToCrate={() => {
                                            if (this.props.onAddToCrate) {
                                                this.setState({ loadingId: album.id })
                                                Promise.all(album.media.map(i => {
                                                    return this.props.onAddToCrate!(i)
                                                })).finally(() => {
                                                    this.setState({ loadingId: undefined })
                                                })
                                            }

                                        }} onShare={() => {
                                            shareAlbum(album)
                                        }}
                                    />
                                </Col>
                            )
                        })}
                    </Row>
                </Container>
            </>
        )
    }

}

export interface GridListItemProps {
    album: BPMAlbum
    loading: boolean
    onItemClick?: () => void
    onPlay: () => void
    onDownload: (media: BPMMedia) => void
    onAddToCrate: () => void
    onAddToQueue?: () => void
    onShare?: () => void
}

export class GridListItem extends React.Component<GridListItemProps, {}> {

    private isAlbumSelected(album: BPMAlbum, playerContext: PlayerContext) {
        if (playerContext && playerContext.state >= PlayerState.Loading) {
            return album.media.find(m => m.id == playerContext!.track!.track.id) != undefined
        }
        return false;
    }

    render() {
        let dropDownItems = []
        if (this.props.onDownload) {
            dropDownItems.push({
                title: 'Download', items: this.props.album.media.map(m => {
                    return {
                        title: m.tag!.name,
                        onClick: (e: React.MouseEvent<HTMLElement>) => {
                            this.props.onDownload!(m)
                        }
                    }
                })
            })
        }
        if (this.props.onAddToCrate) {
            dropDownItems.push({ title: 'Add to Crate', onClick: this.props.onAddToCrate! })
        }
        if (this.props.onAddToQueue) {
            dropDownItems.push({ title: 'Add to Queue', onClick: this.props.onAddToCrate! })
        }
        if (this.props.onShare) {
            dropDownItems.push({
                title: 'Share link', onClick: this.props.onShare
            })
        }
        const { album } = this.props
        return (
            <div className="gridlist-item-container" onClick={this.props.onItemClick} style={{ cursor: this.props.onItemClick ? 'pointer' : 'auto' }}>
                <img className="cover" src={album.cover} />
                <div className={"play-pause-overlay " + (this.props.loading ? 'loading' : '')}>
                    <PlayerContextConsumer>{(value) => {
                        return (
                            <>
                                {this.props.loading && <Loader size={20} />}
                                <span style={{ cursor: 'pointer' }} onClick={(e) => {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    if (this.isAlbumSelected(album, value)) {
                                        PlaybackManager.getInstance().pause()
                                    } else {
                                        this.props.onPlay()
                                    }
                                }}>
                                    <div className="play-background">
                                        {!this.props.loading && this.isAlbumSelected(album, value) && <img src={PAUSE_SMALL_WHITE_SVG} />}
                                        {!this.props.loading && !this.isAlbumSelected(album, value) && <img src={PLAY_SMALL_WHITE_SVG} />}
                                    </div>
                                </span>
                            </>
                        )
                    }}</PlayerContextConsumer>

                </div>
                <div className="text-container">
                    <div className="flex-row">
                        <div style={{ overflow: 'hidden' }}>
                            <div className="flex-col">
                                <span className="item-text item-title">{album.name}</span>
                            </div>
                            <div className="flex-col">
                                <span className="item-text item-subtitle">{album.artist}</span>
                            </div>
                        </div>
                        <BrowseDropDown items={dropDownItems} />
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/views/GridList.tsx